import React from "react";
import { Accordion, AccordionItem } from "./Accordion";
import { faqsData, Vslfaqs } from "../../../../constant/data";

const FAQ = () => {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 py-12">
      <div className="text-center flex flex-col justify-center items-center mb-12">
        <div className="w-36 h-2 bg-[#132C4D] mb-6"></div>
        <h2 className="text-4xl text-black font-bold">Frequently Asked Questions</h2>
      </div>

      <Accordion>
        {faqsData.map((faq, index) => (
          <AccordionItem
            key={index}
            question={faq.question}
            answer={faq.answer}
            faqImg={faq.img}
          />
        ))}
      </Accordion>
    </div>
  );
};

export default FAQ;
